import React from 'react'
import FilterMultiDate from "./FilterMultiDate"
import PropTypes from 'prop-types'
import MultiSelectSearch from "../../../shared/components/MultiSelectSearch";
import {Button} from "antd";

ReportDetailSubSearch.propTypes = {
    receptionDateFrom: PropTypes.string,
    receptionDateTo: PropTypes.string,
    onChangeFrom: PropTypes.func,
    onChangeTo: PropTypes.func
}

function ReportDetailSubSearch(props) {
    const {
        tenants,
        filters,
        onChangeFilters,
        receptionDateFrom,
        receptionDateTo,
        onChangeFrom,
        onChangeTo,
        fetchListReport,
        fetchListOutputReport
    } = props

    const _handleChangeSelect = (values) => {
        onChangeFilters('tenantId', values)
    }

    const _fetchListReport = () => {
        fetchListReport()
    }

    const _fetchListOutputReport = () => {
        fetchListOutputReport()
    }

    return (
        <div className="PageFilters">
            <FilterMultiDate
                receptionDateFrom={receptionDateFrom}
                receptionDateTo={receptionDateTo}
                onChangeFrom={onChangeFrom}
                onChangeTo={onChangeTo}
            />
            <div className="itemFilter">
                <MultiSelectSearch
                    listSelect={tenants} name="tenantId"
                    value={filters.tenantId}
                    label="Khách hàng"
                    onChange={_handleChangeSelect}
                />
            </div>
            <div className="itemFilter">
                <Button type="primary" style={{marginTop: "27px"}} onClick={_fetchListReport}>Tìm kiếm chi tiết
                    sub</Button>
                <Button type="primary" style={{marginLeft: "15px"}} onClick={_fetchListOutputReport}>Tìm kiếm sản
                    lượng</Button>
            </div>
        </div>
    )
}

export default ReportDetailSubSearch
